import {useEffect, useState} from 'react'
import {usersAPI} from '../../../services/UsersService'
import ToggleButton from 'react-bootstrap/esm/ToggleButton'
import {updateQuery, setQuery} from '../slices/hrFilterSlice'
import {useAppDispatch, useAppSelector} from '../../../hooks/redux'
import ToggleButtonGroup from 'react-bootstrap/esm/ToggleButtonGroup'
import {shallowEqual} from 'react-redux'
import {Link, useLocation, useParams} from 'react-router-dom'
import {KTSVG} from '../../../template/helpers'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {HrFilter} from './HrFilter'
import {DateRangePickerHr} from '../helpers/DateRangePickerHr'

type IToggleButtonValue = 'ALL' | 'INBOUND' | 'OUTBOUND' | 'MISSED'

const HrHeader = () => {
  const {appId} = useParams()
  const location = useLocation()
  const dispatch = useAppDispatch()
  const {data: currentUser} = usersAPI.useFetchGetMeQuery()
  const query = useAppSelector((state) => state.hrFilter.query, shallowEqual)
  const [toggleButtonValue, setToggleButtonValue] = useState<IToggleButtonValue>('ALL')
  const [linkCdr] = useState<string>(location.pathname.includes('/management') ? '/management/cdr' : '/cdr')

  useEffect(() => {
    if (query) {
      if (!query.direction && !query.status) {
        setToggleButtonValue('ALL')
      } else if (query.status === 'NO_ANSWER' && query.direction === 'INBOUND') {
        setToggleButtonValue('MISSED')
      } else if (query.direction === 'INBOUND') {
        setToggleButtonValue('INBOUND')
      } else if (query.direction === 'OUTBOUND') {
        setToggleButtonValue('OUTBOUND')
      }
    }
  }, [query])

  return (
    <div className='card-header border-1'>
      <div className='d-flex mt-2 align-items-center w-100 gap-2'>
        <div className='w-290px'>
          <DateRangePickerHr
            language={currentUser?.language}
            timeZone={currentUser?.time_zone}
            rangeId='1'
            onlyIcon={false}
          />
        </div>
        <HrFilter />
        <div>
          <ToggleButtonGroup
            type='radio'
            name='options'
            defaultValue={'ALL'}
            onChange={(val) => {
              setToggleButtonValue(val)
            }}
          >
            <ToggleButton
              id='tbg-radio-1'
              value={'ALL'}
              variant={toggleButtonValue === 'ALL' ? 'primary' : 'outline-primary'}
              size='sm'
              onClick={() => {
                const {status, direction, ...rest} = query || {}
                dispatch(setQuery({...rest}))
              }}
            >
              Все
            </ToggleButton>
            <ToggleButton
              id='tbg-radio-2'
              value={'INBOUND'}
              variant={toggleButtonValue === 'INBOUND' ? 'primary' : 'outline-primary'}
              size='sm'
              onClick={() => {
                const {status, ...rest} = query || {}
                dispatch(setQuery({...rest, direction: 'INBOUND'}))
              }}
            >
              <i className='bi bi-arrow-down-right-circle fs-3' /> Входящие
            </ToggleButton>
            <ToggleButton
              id='tbg-radio-3'
              value={'OUTBOUND'}
              variant={toggleButtonValue === 'OUTBOUND' ? 'primary' : 'outline-primary'}
              size='sm'
              onClick={() => {
                const {status, ...rest} = query || {}
                dispatch(setQuery({...rest, direction: 'OUTBOUND'}))
              }}
            >
              <i className='bi bi-arrow-up-left-circle fs-3' />
              Исходящие
            </ToggleButton>
            <ToggleButton
              id='tbg-radio-4'
              value={'MISSED'}
              variant={toggleButtonValue === 'MISSED' ? 'primary' : 'outline-primary'}
              size='sm'
              onClick={() => {
                dispatch(updateQuery({...query, direction: 'INBOUND', status: 'NO_ANSWER'}))
              }}
            >
              <i className='bi bi-x-circle fs-3' />
              Пропущенные
            </ToggleButton>
          </ToggleButtonGroup>
        </div>
        <div className='ms-auto'>
          <OverlayTrigger
            delay={{show: 50, hide: 50}}
            overlay={
              <Tooltip id='tooltip-title' style={{position: 'fixed'}}>
                Перейти к журналу звонков
              </Tooltip>
            }
          >
            <Link to={`${linkCdr}/${appId}`}>
              <span className='badge badge-light-success cursor-pointer'>
                <KTSVG path='/media/icons/duotune/files/fil002.svg' className='svg-icon-success' />
              </span>
            </Link>
          </OverlayTrigger>
        </div>
      </div>
    </div>
  )
}

export {HrHeader}
